module.exports = __webpack_public_path__ + "static/img/function-box-img7.f16ff82.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/fusionIntegration/function-box-img7.png
// module id = JIa9
// module chunks = 0